import React, {createContext, useState} from 'react';
import {useForm} from "react-hook-form";
import {DocumentTemplateService, SectionService, StatementService, DocumentService} from "../../services";

export const ShippingInstructionContext = createContext();

export const ShippingInstructionProvider = props => {
    const [data, setData] = useState({});
    const [sections, setSections] = useState([]);
    // const [statementSets, setStatementSets] = useState([]);
    const [statements, setStatements] = useState([]);
    const [documentTemplates, setDocumentTemplates] = useState([]);
    const [otherDocuments, setOtherDocuments] = useState([]);
    React.useEffect(() => {

        DocumentTemplateService.getAll()
            .then((response) => {
                setDocumentTemplates(response.data);
            });

   
            DocumentService.getAll()
            .then((response) => {
                setOtherDocuments(response.data);
            });

        StatementService.getAll()
            .then((response) => {
            setStatements(response.data)
        })

        SectionService.getAll().then((response) => {
            setSections(response.data)
        });

    }, []);


    const methods = useForm({shouldFocusError:true});

    return (
        <ShippingInstructionContext.Provider
            value={{data, setData, methods, sections, setSections, documentTemplates, statements, otherDocuments}}>
            {props.children}
        </ShippingInstructionContext.Provider>
    );
}